import React from 'react';
import NumberFormatter from '../../../app/formatters/NumberFormatter';

export default function CashregisterProductVariation({ product, paramStock, paramShowimages, onChangeOnProductVariation }) {
  var style = paramShowimages
    ? {
        backgroundImage: `url(${product.thumbnail || '/images/NO_THUMBNAIL.webp'})`
      }
    : {};

  return (
    <a className="cashregister__product cashregister__product--no-padding" href="#">
      <div className="cashregister__product-image" style={style}></div>
      <div className="cashregister__padding">
        <h5 className="cashregister__card-name">{product.name}</h5>
        <div className="cashregister__line">{NumberFormatter.formatNumber(product.ttc_price)}</div>
        <div className="cashregister__line">
          <select className="cashregister__select" name="variationId" onChange={onChangeOnProductVariation}>
            <option value="">Sélectionnez une valeur</option>
            {product.product_variations.map((productVariation, index) =>
              paramStock && !product.unlimited_stock ? (
                <option key={index} value={productVariation.id}>
                  {productVariation.variation} (Stock. : {productVariation.stock})
                </option>
              ) : (
                <option key={index} value={productVariation.id}>
                  {productVariation.variation}
                </option>
              )
            )}
          </select>
        </div>
      </div>
    </a>
  );
}
